import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoneOutlined, SoundOutlined, EnvironmentOutlined } from '@ant-design/icons';
import './common.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import recallNoticeSvg from '../../assets/recall-notice.svg';
import noDataSvg from '../../assets/no-data.svg';
import Loading from 'pages/toyotaOfficialAccount/Loading';
import Error from 'pages/toyotaOfficialAccount/Error';

import { AuthValid } from 'shared/httpHandler';
import { encodeBase64Object } from 'shared/common';
import axios from 'axios';

const recallData = [
  {
    id: 1,
    date: '2025/05/02',
    status: '未完成',
    statusClass: 'recall-unfinished',
    desc: 'TOYOTA YARIS CROSS座椅螺栓索付不良召回(202505)'
  },
  {
    id: 2,
    date: '2024/05/01',
    status: '已完成',
    statusClass: 'recall-finished',
    desc: 'TOYOTA YARIS CROSS座椅螺栓索付不良召回(202405)'
  }
];

const RecallNotice = () => {

  const [token, setToken] = useState('');
  const [carNo, setCarNo] = useState('');
  const [lineId, setLineId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [serviceName, setServiceName] = useState(null);
  const [servicePhone, setServicePhone] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    try {
      const payload = AuthValid.parseJwt(token);
      setToken(token);
      setLineId(payload.sub);
      setCarNo(payload.carNo);
    } catch (error) {
      console.error('Failed to parse JWT token:', error);
      setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
      setDisplayError(true);
    }
  }, []);

  useEffect(() => {
    if (token && lineId && carNo) {
      const queryParams = new URLSearchParams(encodeBase64Object({
        car_no: carNo,
        auth_token: token
      }));
      
      const getRecallNotice = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/recall?${queryParams.toString()}`);
          setRecords(response.data.data || []);
        } catch (error) {
          console.error('Failed to get maintenance record:', error);
          console.log(error.status);
          if( error.status >= 400 && error.status <= 499) {
            setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
          }
          setDisplayError(true);
        }
      }
      
      const getServicePhoneByCarNo = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/service_phone?${queryParams.toString()}`);
          setServiceName(response.data.data?.brnhnm || '');
          setServicePhone(response.data.data?.tel || '');
        } catch (error) {
          console.error('Failed to get service phone:', error);
          if( error.status >= 400 && error.status <= 499) {
            setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
          }
          setDisplayError(true);
        }
      }
      
      Promise.all([getRecallNotice(), getServicePhoneByCarNo()])
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [token, lineId, carNo]);

  if (isLoading) {
    return <Loading />;
  }

  if (displayError) {
    return <Error message={errorMessage} />;
  }

  return (
    <div className="center-viewport">
      <div className="maintenance-app">
        {/* Toyota Logo */}
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Decorative dots 可依需求移除或保留 */}
          {/* Header */}
          <div className="content-header">
            <div className="header-row">
              <div className="header-text">
                <div className="vehicle-number">{carNo}</div>
                <h1 className="page-title">召修公告</h1>
              </div>
              <div className="header-icons">
                <img src={recallNoticeSvg} alt="召修icon"/>
              </div>
            </div>
            <p className="description">
              如尚未實施，請盡速聯絡服務廠回廠實施。
            </p>
          </div>

          {/* Recall List */}
            <div className="car-list-container">
              {records.map((item, index) => (
                <div key={index} className="card-container">
                  <div className="record-header">
                    <span className="text-muted-base">公告日期：{item.DUEDT_S}</span>
                    {item.DONE === '已完成' ? (
                      <span className={`record-type recall-finished`}>已完成</span>
                    ) : (
                      <span className={`record-type recall-unfinished`}>未完成</span>
                    )}
                  </div>
                  <div className="record-divider" />
                  <div className="record-details">
                    <div className="flex-between text-base">
                      <span className="text-dark-base">{item.DESC_C}</span>
                    </div>
                  </div>
                </div>
              ))}
              {records.length === 0 && (
                <div className="card-container">
                  <div className="no-data-block">
                    <img src={noDataSvg} alt="no data" className="no-data-img" />
                  <div className="text-muted-base font-medium">目前尚無資料</div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </div>
      {/* 底部固定按鈕群組 */}
      <div className="bottom-btn-bar">
        <button className="action-btn" type="button" onClick={() => window.location.href=`tel:${servicePhone}`} style={{display: servicePhone ? 'block' : 'none'}}>
          <PhoneOutlined style={{ fontSize: '1.2em' }} /> 預約回廠服務{serviceName && `（${serviceName}）`}
        </button>
        <div className="btn-group">
          <button
            className="tertiary-btn"
            type="button"
            onClick={() => window.open('https://www.toyota.com.tw/owner_news.aspx', '_blank', 'noopener,noreferrer')}
          >
            <SoundOutlined style={{ fontSize: '1.2em' }} /> 召回公告
          </button>
          <button
            className="tertiary-btn"
            type="button"
            onClick={() => window.open('https://www.toyota.com.tw/location.aspx', '_blank', 'noopener,noreferrer')}
          >
            <EnvironmentOutlined style={{ fontSize: '1.2em' }} /> 服務據點
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecallNotice; 